export default function getAdminSetting(key: string) {
  try {
    const str = localStorage.getItem("adminSettings");
    if (str === null) {
      return null;
    }
    return JSON.parse(str)[key];
  } catch (error) {
    return null;
  }
}
